/**
 * Matter Roles — directApiClient mutations (LF-3214)
 */

'use client';

import { directApiClient } from '@/lib/api/direct-client';
import { MatterActionResult } from '@/lib/services/matters/types';
import { AssignRoleRequest, AssignRoleResponse } from './types';

export async function assignMatterRoleAction(
  request: AssignRoleRequest
): Promise<MatterActionResult<AssignRoleResponse>> {
  try {
    const response = await directApiClient.post<AssignRoleResponse>(
      `/matters/${request.matterId}/roles`,
      { userId: request.userId, role: request.role }
    );
    return { success: true, data: response };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to assign matter role'
    };
  }
}

export async function removeMatterRoleAction(
  matterId: number,
  userId: number
): Promise<MatterActionResult<void>> {
  try {
    await directApiClient.delete(`/matters/${matterId}/roles/${userId}`);
    return { success: true };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to remove matter role'
    };
  }
}
